"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIMailRecipientSettings = void 0;
const imail_cc_recipients_1 = require("./imail-cc-recipients");
const iquote_approved_mail_recipients_1 = require("./iquote-approved-mail-recipients");
const iquote_sent_mail_recipients_1 = require("./iquote-sent-mail-recipients");
function parseIMailRecipientSettings(data) {
    if (data.quoteSent !== null && typeof data.quoteSent === 'object')
        data.quoteSent = (0, iquote_sent_mail_recipients_1.parseIQuoteSentMailRecipients)(data.quoteSent);
    if (data.quoteApproved !== null && typeof data.quoteApproved === 'object')
        data.quoteApproved = (0, iquote_approved_mail_recipients_1.parseIQuoteApprovedMailRecipients)(data.quoteApproved);
    if (data.upcomingMaintenance !== null && typeof data.upcomingMaintenance === 'object')
        data.upcomingMaintenance = (0, imail_cc_recipients_1.parseIMailCcRecipients)(data.upcomingMaintenance);
    if (data.plannedNotification !== null && typeof data.plannedNotification === 'object')
        data.plannedNotification = (0, imail_cc_recipients_1.parseIMailCcRecipients)(data.plannedNotification);
    if (data.feedback !== null && typeof data.feedback === 'object')
        data.feedback = (0, imail_cc_recipients_1.parseIMailCcRecipients)(data.feedback);
    return data;
}
exports.parseIMailRecipientSettings = parseIMailRecipientSettings;
